export const cardInfoValidationError = {
  cardNumber1: "16자 길이의 숫자만 입력해주세요.",
  cardNumber2: "16자 길이의 숫자만 입력해주세요.",
  cardNumber3: "16자 길이의 숫자만 입력해주세요.",
  cardNumber4: "16자 길이의 숫자만 입력해주세요.",
  expireDate1: "유효한 월을 입력해주세요.",
  expireDate2: "유효한 년도를 입력해주세요.",
  holderName: "30자 이내의 영문만 입력해주세요.",
  securityCode: "3자 길이의 숫자만 입력해주세요.",
  password1: "2자 길이의 숫자만 입력해주세요.",
  password2: "2자 길이의 숫자만 입력해주세요.",
};
